<template>
	<div class="c-panel c-panel--small">

		<h3 class="margin-b-8">Tweestapsverificatie</h3>
		<p>Dit zorgt voor een betere beveiliging van je account. Dankzij deze authenticatie kun je ongewenste personen buitensluiten, zelfs als ze je wachtwoord hebben. </p>

		<h6 class="margin-b-8">Google Authenticator</h6>
		<p>Wij maken gebruik van Google Authenticator. Google Authenticator genereert codes voor verificatie in twee stappen op je telefoon. De apps zijn beschikbaar voor iPhone en Android.</p>

		<div class="margin-b-16 text-center">
			<a target="_blank" href='https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2'>
				<img alt='Ontdek het op Google Play' width="200" src='/img/google-play-badge.png'/>
			</a>
		</div>
		
		<div class="text-center">
			<a target="_blank" href='https://apps.apple.com/nl/app/google-authenticator/id388497605'>
				<img alt='Bekijk in de App Store' width="200" src='/img/apple-app-store-badge.png'/>
			</a>
		</div>

		<router-link class="c-btn c-btn--expanded margin-t-32 no-margin-b" :to="{name: 'two-factor-authentication-qr'}">Volgende stap</router-link>

	</div>
</template>

<script>
import Form from '@mixins/Form';

export default {
	mixins: [Form],
	data() {
		return {
			
		}
	},
	created() {

             this.$xhr.get('/api/auth/google2fa/qrcode/').then( ({result}) => {
                if ( result && result.qrcode ) {
                    this.enabled = false;
                    this.qrcode = result.qrcode;
                }
            }).catch((e) => { 
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'QR-code kan niet worden ingeladen'});
				});
        }
}
</script>